import coreStore from "./core-store";

const remoteResource = 'cashflow/api/v1/cash-flow-report-columns';

export default coreStore.createCoreStore('cashflowReportColumn', remoteResource);
